import { isLength } from 'validator';
import { Attach } from '@tools/attach';
import { replaceElement } from '@tools/dom';
import { TwigFormValidator } from '@tools/twig-form/validator';
import { initVuePhoneInput } from '@atoms/twig-phone-input';

/**
 * Organization profile edit component
 */
export const initProfileEdit = () => {
  let phoneInputApp;

  function initFormValidation() {
    const validator = new TwigFormValidator({
      formSelector: '#organization-profile-edit form',
      rules: {
        'app_organization_profile[name]': [ 'required', (value) => isLength(value, { max: 50 }) ],
        'app_organization_profile[phoneNumber]': 'phone',
      },
      onFailure: (event, messages) => {
        const phoneError = messages['app_organization_profile[phoneNumber]'];
        phoneInputApp.error = phoneError ?? null;
      },
      onSuccess: (event) => {
        phoneInputApp.error = null;
        Attach.asyncSubmit(event).then((result) => {
          if (result.data.reload) {
            window.location.reload();
          } else {
            replaceElement('#organization-profile-edit .container', result.data, '.container');
            processForm(); // eslint-disable-line no-use-before-define
          }
        });
      },
    });
    validator.init();
  }

  function processForm() {
    phoneInputApp = initVuePhoneInput('vue-phone-input');
    initFormValidation();
  }

  if (document.getElementById('organization-profile-edit')) {
    processForm();
  }
};
